import React from 'react';
import * as Yup from 'yup';
import { BiImageAdd } from 'react-icons/bi';

import FileInput from '../../../../../../newComponents/FileInput';

import { useSimpleProduct } from '../../../../../../hooks/simpleProduct';

import { Container } from './styles';

export const ImagesFormSchema = Yup.object().shape({});

const Images: React.FC = () => {
  const { images, handleChangeImage } = useSimpleProduct();

  return (
    <Container>
      {images.map((image, index) => (
        <FileInput
          id={`simpleProductImage-${index}`}
          icon={BiImageAdd}
          title={`Imagem ${index + 1}`}
          selectedImage={image?.file}
          acceptableTypes=".jpeg,.jpg,.png"
          subtitle="Formatos: .jpeg, .jpg, .png"
          onRemove={() => handleChangeImage(index, undefined)}
          onSelectFile={(imageToChange) =>
            handleChangeImage(index, imageToChange)
          }
        />
      ))}
    </Container>
  );
};

export default Images;
